import ApiService from "./api.service";
export default class AvailableSlotsService extends ApiService {
    static base_url = `${super.base_url}/available_slots`;

    static async batch(data, axiosInstance, config = {}) {
        const response = await axiosInstance.post(`${this.base_url}/batch`, data, config);
        return response.data;
    }
}
